/**
 * Merchant payment details shown on the pay screen (QR, bank transfer, UPI deep link).
 * Payee name and bank fields match the static QR / bank instructions.
 * Set REACT_APP_MERCHANT_UPI_ID to the same VPA encoded in your payment QR.
 */
export const PAYMENT_MERCHANT = {
  payeeName: 'Iconnect Electronet LLP',
  upiId: (process.env.REACT_APP_MERCHANT_UPI_ID || '').trim(),
  transactionNotePrefix: 'I-Connect payment',
};

export const PAYMENT_BANK_DETAILS = [
  { label: 'Account Number', value: '926020021896676', mono: true },
  { label: 'Account Name', value: PAYMENT_MERCHANT.payeeName },
  { label: 'IFSC Code', value: 'UTIB0001901', mono: true },
  { label: 'Branch', value: 'Axis Bank Moodbidri' },
];

export const PAYMENT_QR_IMAGE = `${process.env.PUBLIC_URL}/images/payment_qr_code.png`;
